/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './weight.reducer';

export const WeightDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const weightEntity = useAppSelector(state => state.weight.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="weightDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.weight.detail.title">Weight</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.weight.id">Id</Translate>
            </span>
          </dt>
          <dd>{weightEntity.id}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.weight.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{weightEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.weight.active">Active</Translate>
            </span>
          </dt>
          <dd>{weightEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="tinyMedicRestApp.weight.created">Created</Translate>
            </span>
          </dt>
          <dd>{weightEntity.created ? <TextFormat value={weightEntity.created} type="date" format={APP_DATE_FORMAT} /> : null}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.weight.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{weightEntity.microSec}</dd>
          <dt>
            <span id="reading">
              <Translate contentKey="tinyMedicRestApp.weight.reading">Reading</Translate>
            </span>
          </dt>
          <dd>{weightEntity.reading}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.weight.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{weightEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.weight.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{weightEntity.lastupdated}</dd>
          <dt>
            <span id="height">
              <Translate contentKey="tinyMedicRestApp.weight.height">Height</Translate>
            </span>
          </dt>
          <dd>{weightEntity.height}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.weight.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{weightEntity.glucoUser ? weightEntity.glucoUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/weight" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/weight/${weightEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default WeightDetail;
